import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Платформа';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>4-ох осная платформа №412-0000</p>
                    <p>Изготовлена в 1953 году на вагоностроительном заводе имени газеты Правда, город Днепрдзежинск</p>
                    <p>Кузов вагона деревянной конструкции, обшит листовым железом</p>
                    <p>Грузоподъемность - 62т</p>
                    <p>Тара - 21т</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt083.jpg')} /></div>
            </div>
        </>
    );
}